export const matchMqttTopic = (action, topic, position) =>
    action?.type?.startsWith('MQTT/') ? action.type.split('/')[position] === topic : false;
